import {Text} from '@/components/Typography';
import useInsightTiles from '@/hooks/experienceScore/useInsightTiles';
import {getContent} from '@/services/content/content';

import InsightTile from './InsightTile';

const InsightSection = () => {
    const tiles = useInsightTiles();
    const {insightsTitle} = getContent().experienceScoreContent ?? {};

    if (tiles.length === 0) return null;

    return (
        <div className='mt-8 flex w-full flex-col gap-4'>
            <Text as='h2' variant='subsectionTitle' className='w-full text-left'>
                {insightsTitle}
            </Text>
            <div className='grid grid-cols-2 gap-2'>
                {tiles.map((tile) => (
                    <InsightTile key={tile.code} tile={tile} />
                ))}
            </div>
        </div>
    );
};

export default InsightSection;
